import React from 'react';
import { inject, observer} from 'mobx-react';
import {WeaTop, WeaTab,WeaRightMenu,WeaTools} from 'ecCom';
import {Spin,Button} from 'antd';
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty';
const toJS = mobx.toJS;
import * as PublicFunc from '../util/pulic-func';
import moment from 'moment';
import {WeaTableNew} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;
import {i18n} from '../public/i18n';
let _this;

@inject('hrmUnderling')

@observer
class HrmUnderling extends React.Component {
  constructor(props) {
    super(props);
    _this = this;
    const funcs = ['onOperatesClick','jumpToHrmCard'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }

  componentDidMount() {
   this.init();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.location.key !== nextProps.location.key) {
     this.init();
    }
  }

  init(){
    const { hrmUnderling } = this.props;
    let hrmId = this.props.params.hrmId || '';
    hrmUnderling.id = hrmId;
    hrmUnderling.lastname = '';
    hrmUnderling.showAllLevel = false;
    hrmUnderling.getSearchList();
  }

  getTopButtons() {
    const { hrmUnderling } = this.props;
    const { showAllLevel } = hrmUnderling;
    let btns =[];
  
    const btnShowAllLevel = <Button size="small" style={{height: '28px'}} onClick={()=>this.changeShowAllLevel()} title={showAllLevel?i18n.button.directSubordinates():i18n.button.DisplaySubordinateSubordinates()}>
                            <span>{showAllLevel?
                                  <i className='icon-coms-DisplaySubordinates' style={{color: '#2db7f5'}}/>
                                  :<i className='icon-coms-NoDisplayOfSubordinates'/>}</span>
                          </Button>;
    btns.push(btnShowAllLevel);
    btns.push(<Button type="primary" onClick={()=>hrmUnderling.getSearchList()} >{i18n.button.search()}</Button>);
    return btns;
  }

  changeShowAllLevel(){
    const { hrmUnderling } = this.props;
    hrmUnderling.changeShowAllLevel();
  }

  render(){
    const { hrmUnderling } = this.props;
    let {title,lastname,table} = hrmUnderling;

    if(window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){
      if(title){
          document.title=title;
      }
    }

    return (
      <div className='wea-myhrm-Underling'>
      <WeaRightMenu datas={this.getRightMenu()}>
        <WeaTop
          title={title}
          icon={<i className='icon-coms-hrm' />}
          iconBgcolor='#217346'
          buttons={this.getTopButtons()}
          buttonSpace={10}
          showDropIcon={true}
          dropMenuDatas={this.getRightMenu()}
        >
        <WeaTab
          searchType={['base']}
          searchsBaseValue={lastname}
          onSearch={v => {hrmUnderling.getSearchList()}}
          onSearchChange={v => {
            hrmUnderling.lastname = v;
          }}
        />
        <WeaTable
          comsWeaTableStore={table}
          hasOrder={true}
          needScroll={true}
          getColumns={c=>this.reRenderColumns(c)}
          onOperatesClick={this.onOperatesClick}
          />
        </WeaTop>
        </WeaRightMenu>
      </div>
    );
  }

  reRenderColumns(columns){
    columns.forEach(c=>{
        if(c.dataIndex=='lastname'){
            c.render = function(text, record){
                return  <span style={{cursor:'pointer'}} className='wea-hrm-linkstyle' onClick={_this.jumpToHrmCard.bind(null,record.id)}>{record.lastname}</span>
            }
        } else {
          c.render = function(text, record){
              let valueSpan = record[c.dataIndex + "span"] !== undefined ? record[c.dataIndex + "span"] : record[c.dataIndex];
              return <span dangerouslySetInnerHTML={{__html: valueSpan}}></span>
            }
        }
    })
    return columns;
  }

  onOperatesClick=(record,index,operate,flag,argumentString)=>{
    const fn = operate.href ? operate.href.split(':')[1].split('(')[0] : '';
    const id = record.id ? record.id : '';
    PublicFunc[fn](id);
  }

  jumpToHrmCard(hrmId,...rest){
    PublicFunc.jumpToHrmCard(hrmId);
  }

  getRightMenu(){
    const keys = this.getSelectedRowKeys();
    const { hrmUnderling } = this.props;
    const arr = [{
        icon: <i className='icon-coms-ws'/>,
        content:i18n.button.search(),
        key: 'getSearchList',
        onClick: key =>{
          hrmUnderling.getSearchList();
        }
      }, {
        icon: <i className='icon-coms-task-list'/>,
        content:i18n.button.columnVisibleSetting(),
        key: 'definedColumn',
        onClick: key =>{
          this.definedColumn();
        }
      }
    ];
    return arr;
  }

  getSelectedRowKeys(){
    const { hrmUnderling } = this.props;
    const { table } = hrmUnderling;
    const selectedRowKeys = table.selectedRowKeys;
    return selectedRowKeys;
  }

  definedColumn() {
    const { hrmUnderling } = this.props;
    const { table} = hrmUnderling;
    table.setColSetVisible(true);
    table.tableColSet(true);
  }
}

export default HrmUnderling



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/Underling.js